<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormBisel" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objBisel.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-x12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objBisel.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
                        <label class="form-label" for="">Especificaciones:</label>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
                                    <input type="checkbox" v-model="objBisel.ReqArmazon" class="form-check-input" id="ReqArmazon" />
                                </div>
                                <span>Requiere Armazón</span>
                            </div>
							<CValidation v-if="this.errorvalidacion.ReqArmazon" :Mensaje="'*'+errorvalidacion.ReqArmazon[0]"/>
						</div>
				
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-x6">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
                                    <input @change="VaciarSubbiseles" type="checkbox" v-model="objBisel.SubRegistro" class="form-check-input" id="SubRegistro" />
                                </div>
                                <span>Subregistro</span>
                            </div>
							<CValidation v-if="this.errorvalidacion.SubRegistro" :Mensaje="'*'+errorvalidacion.SubRegistro[0]"/>
						</div>
                    </div>
                    <div v-if="!objBisel.SubRegistro" class="form-group row">
                        <label class="form-label" for="">Bisel:</label>
						<div v-for="(item, idx) in ListSubbisel" :key="idx" class="col-12 col-sm-12 col-md-12 col-lg-12 col-x12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
                                    <input type="checkbox" v-model="item.Checked" class="form-check-input" id="" />
                                </div>
                           
                                <span>{{ item.Nombre }}</span>
                            </div>
						</div>
                        <CValidation v-if="this.errorvalidacion.ReqArmazon" :Mensaje="'*'+errorvalidacion.ReqArmazon[0]"/>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import CorreoRespuesta from '@/views/segurity/CorreoRespuesta.vue';


export default {
    name: 'FormBisel',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objBisel: {
				IdBisel: 0,
				Nombre: '',
				Clave: '',
				SubRegistro: false,
				ReqArmazon: false,
            },
            Subbiseles:[],
            ListSubbisel:[],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
            let dataBisel = this.CrearCopiaObjBisel(this.objBisel,this.Subbiseles);
			if(this.objBisel.IdBisel == 0) {
				await this.$http.post(
					'biseles',dataBisel
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'biseles/'+this.objBisel.IdBisel,
					dataBisel
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "biseles/"+this.objBisel.IdBisel
            ).then((res) => {
                this.objBisel = res.data.data;
                this.objBisel.ReqArmazon = res.data.data.ReqArmazon == 'SI';
                this.objBisel.SubRegistro = res.data.data.SubRegistro == 'SI';
                this.Subbiseles = res.data.subbiseles;
                this.CheckSubiseles();
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objBisel = {
				IdBisel: 0,
				Nombre: '',
				Clave: '',
				SubRegistro: false,
				ReqArmazon: false,
				Bisel:false
            }
            this.ListSubbisel = [];
            this.errorvalidacion = [];
        },
        GetSubbiseles(id){
            if(id == 0) this.ConfigLoad.ShowLoader =  true;
            this.$http.get('/biseles/subbiseles/'+id
            ).then((res)=>{
                this.ListSubbisel = [];
                res.data.data.forEach(elem => {
                    let subbisel = {
                        IdBisel: elem.IdBisel,
                        Nombre: elem.Nombre,
                        Checked: false,
                    }
                    this.ListSubbisel.push(subbisel)
                })
            }).finally(()=> {if(id == 0) this.ConfigLoad.ShowLoader = false}
            ).catch(err => console.error(err));
        },
        CheckSubiseles(){
            this.ListSubbisel.forEach(elem =>{
                elem.Checked = this.Subbiseles.some(elem2 => elem2.IdSubBisel == elem.IdBisel);
            })
        },
        CrearCopiaObjBisel(obj){
            let copia = {...obj}
            copia.SubRegistro = obj.SubRegistro?'SI':'NO'; 
            copia.ReqArmazon = obj.ReqArmazon?'SI':'NO';
            copia['Subbiseles'] = [];
            this.ListSubbisel.forEach(elem => {
                if(elem.Checked) copia.Subbiseles.push(elem.IdBisel)
            }); 
            return copia;
        },
        VaciarSubbiseles(){
            this.Subbiseles = [];
            this.CheckSubiseles();
        }
    },
    created() {
		this.poBtnSave.Toast = 0;
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
            this.GetSubbiseles(Id);
                
            if (Id!='') 
            {
                this.objBisel.IdBisel = Id;
                this.Recuperar();
            }
        });
    }
}
</script>
